<template>
    <div class="custom-made-cate">
        <Row>
            <Col :xs="24" :sm="12">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Button @click="showModel()" type="success" class="f-l">添加</Button>
                </FormItem>
            </Form>
            </Col>
        </Row>
        <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
            </div>
        </div>
        <!-- 添加的弹出 -->
        <Modal v-model="showModalStatus" :title="title" @on-ok="createInfo('dataInfoValidate')" :loading="loading">
            <Form :model="dataInfo" ref="dataInfoValidate" :rules="dataInfoValidate" action="javascript:void(0)">
                <FormItem label="分类名称" prop="title">
                    <Input v-model="dataInfo.title" placeholder="输入分类名称..."></Input>
                </FormItem>
                <FormItem label="状态" prop="status">
                    <RadioGroup v-model="dataInfo.status">
                        <Radio :label="1">正常</Radio>
                        <Radio :label="0">禁用</Radio>
                    </RadioGroup>
                </FormItem>
            </Form>
        </Modal>
    </div>

</template>

<script>
    export default {
        name: "custom-made-cate",
        data () {
            return {
                loading: true,
                dataloading: true,
                thumblist: [],
                pages:{
                    page:1,
                    size:10,
                    total:0
                },
                title:'',
                formItem:{
                    'key':'',
                },
                bigDisplay:'',
                list: [
                    {
                        title: 'Id',
                        key: 'id',
                        fixed: 'left',
                        width:90
                    },
                    {
                        title: '名称',
                        key: 'title',
                        minWidth:200
                    },
                    {
                        title: '状态',
                        key: 'display',
                        minWidth:200,
                        render: (h, params) => {
                            var par = params.row.status == 1 ? '正常' : '禁用';
                            return h('div', [
                                h('span', {
                                }, par)
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width:150,
                        align: 'left',
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style:{
                                        marginRight:'8px'
                                    },
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.detail(params.index,params.row.id)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    style:{
                                        marginRight:'8px'
                                    },
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(params.index,params.row.id)
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tablelist: [],
                dataInfo:{
                    title:'',
                    status:true,
                },
                showModalStatus:false,
                dataInfoValidate: {
                    title: [
                        { required: true, message: '名称必须填写', trigger: 'blur' }
                    ],
                },
            }
        },
        created: function () {
            // 取数据
            this.getTableList();
        },
        components: {
        },
        methods:{
            getTableList:function(){
                this.$api.custommadecate.list({"page":this.pages.page,"size":this.pages.size}).then(res=>{
                    this.dataloading = false;
                    if(res.code == 200)
                    {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 展开添加
            showModel(){
                this.title="添加分类";
                this.dataInfo={
                    name:'',
                    status:1
                };
                this.$refs['dataInfoValidate'].resetFields();
                this.showModalStatus = !this.showModalStatus;
            },
            // 添加
            createInfo(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if(this.dataInfo.id==null || this.dataInfo.id ==0){
                            this.$api.custommadecate.create(this.dataInfo).then(res=>{
                                if(res.code == 200)
                                {
                                    this.getTableList();
                                }
                                this.loading = false;
                                this.$nextTick(()=>{this.loading = true;});
                                this.showModalStatus = !this.showModalStatus;
                            });
                        }else{
                            this.$api.custommadecate.edit(this.dataInfo).then(res=>{
                                if(res.code == 200)
                                {
                                    this.getTableList();
                                }
                                this.loading = false;
                                this.$nextTick(()=>{this.loading = true;});
                                this.showModalStatus = !this.showModalStatus;
                            });
                        }
                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {this.loading = true;});
                    }
                })
            },
            // 删除
            remove:function(index,id){
                // 弹出确认框
                this.$Modal.confirm({
                    title: '警告',
                    content: '<p>此操作不可恢复，三思而后行...</p>',
                    onOk: () => {
                        this.$api.custommadecate.remove({id:id}).then(res=>{
                            if(res.code == 200)
                            {
                                this.$Message.success(res.msg);
                                // this.tablelist.splice(index, 1);
                                this.getTableList();
                            }
                        });
                    }
                });
            },
            // 详情
            detail(index,id){
                this.title="编辑分类";
                this.intangibleCate={
                    name:'',
                    status:1
                };
                this.$refs['dataInfoValidate'].resetFields();
                this.showModalStatus = !this.showModalStatus;
                this.$api.custommadecate.detail({id:id}).then(res=>{
                    this.dataInfo = res.result;
                });
            },
            // 修改状态
            changeStatus:function(index,value){
                this.$api.custommadecate.status({id:index,status:value}).then(res=>{
                    if(res.code == 200)
                    {
                        this.$Message.success(res.msg);
                    }
                });
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.renderTable(1);
            },
            // 筛选
            renderTable:function(name) {
                if (name !=1){
                    this.pages.page = 1;
                }
                this.dataloading = true;
                var ps = {'key':this.formItem.key,"page":this.pages.page,"size":this.pages.size};
                this.$api.custommadecate.list(ps).then(res=>{
                    this.dataloading = false;
                    if(res.code == 200)
                    {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            }
        },
    }
</script>

<style scoped>

</style>